import styled from 'styled-components';
import colors from '../../styles/colors';

export const Container = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;

  border: 1px solid ${colors.aux1};
  border-radius: 2rem;
  font-weight: 900;
  color: #fff;
  background: ${colors.aux1};
  font-size: 1rem;
  line-height: 1.5rem;
  height: 50px;
  width: 250px;
  padding: 0.5rem 2rem;
  display: flex;
  align-items: center;
  justify-content: center;

  transition: filter 0.2s;

  &:hover {
    filter: drop-shadow(0 0 0.25rem rgba(0, 0, 0, 0.5));
  }

  svg {
    margin-left: 0.5rem;
  }
`;
